module.exports = __webpack_public_path__ + "img/logo.33012821.png";